import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";

// Renders text containing LaTeX: $...$ inline and $$...$$ block.
export function MathText({ children, className }) {
  const text = typeof children === "string" ? children : "";
  const parts = [];
  const regex = /(\$\$[\s\S]+?\$\$|\$[^$\n]+?\$)/g;
  let last = 0;
  let m;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) parts.push({ t: "text", v: text.slice(last, m.index) });
    const tok = m[0];
    if (tok.startsWith("$$")) parts.push({ t: "block", v: tok.slice(2, -2).trim() });
    else parts.push({ t: "inline", v: tok.slice(1, -1).trim() });
    last = regex.lastIndex;
  }
  if (last < text.length) parts.push({ t: "text", v: text.slice(last) });
  if (parts.length === 0) parts.push({ t: "text", v: text });

  return (
    <span className={className}>
      {parts.map((p, i) => {
        if (p.t === "text") return <span key={i} className="whitespace-pre-wrap">{p.v}</span>;
        const err = () => <span className="text-white/80">{p.v}</span>;
        return p.t === "block"
          ? <BlockMath key={i} math={p.v} renderError={err} />
          : <InlineMath key={i} math={p.v} renderError={err} />;
      })}
    </span>
  );
}
